import { Modal } from "react-bootstrap";
import { ModalBase } from "../../utils/modal_launcher";
import { formResponse, useApiGet, useApiMutation } from "../../utils/api";
import { useState } from "react";
import { SimpleForm } from "../../utils/simple_form";
import { toast } from "react-toastify";

const fields: Record<string, any> = {
  email: { required: true },
  first_name: {},
  last_name: {},
  role: {
    type: "select",
    options: ["user", "admin"],
    required: true,
  },
};

export const UserModal = ({ id, close, refetch }) => {
  const { post, saving } = useApiMutation();
  const [errors, setErrors] = useState({});
  const { data, unavailable } = id
    ? useApiGet(`/api/admin/user/${id}`)
    : { data: null, unavailable: null };

  if (id && unavailable) {
    return unavailable;
  }

  const user = id ? data?.user : {};

  const submit = (values) => {
    const endpoint = id ? "/api/admin/update_user" : "/api/admin/create_user";
    const payload = id ? { user_id: id, user: values } : { user: values };
    setErrors({});

    post(endpoint, payload).then(
      formResponse(() => {
        refetch();
        toast.success("User saved");
        close();
      }, setErrors)
    );
  };

  return (
    <ModalBase title={id ? "Edit User" : "New User"} close={close}>
      <Modal.Body>
        <SimpleForm
          fields={fields}
          data={user}
          onSubmit={submit}
          saving={saving}
          errors={errors}
        />
      </Modal.Body>
    </ModalBase>
  );
};
